import {
  FINTRAC_STR_SUSPICION_TYPE_CODES_OPTIONS,
  FINTRAC_STR_PROJECT_CODES_OPTIONS,
  FINTRAC_STR_YES_NO_OPTIONS,
} from 'app/modules/fintracStr/formConstants';
import { getDependentPaths } from 'app/modules/fintracStr/formUtils';
import { FintracFormSection } from 'app/modules/fintracStr/models';
import { isFieldBlank } from 'app/modules/fintracStr/renderConditions';
import { U21FormFieldTypes } from 'app/shared/u21-ui/components';

export const FINTRAC_STR_DETAILS_OF_SUSPICION_TAB_SECTION: FintracFormSection =
  {
    type: 'tabSection',
    repeatable: false,
    label: 'Suspicious Activity Information',
    name: 'detailsOfSuspicion',
    mustExistInPayload: true,
    mustHaveValueIfExist: false,
    fields: [
      {
        type: U21FormFieldTypes.TEXTAREA,
        name: 'descriptionOfSuspiciousActivity',
        label: 'Description of suspicious activity',
        dependentPaths: (sectionIndex, fieldSectionIndex) =>
          getDependentPaths(
            undefined,
            ['reportDetails.ministerialDirectiveCode'],
            sectionIndex,
            fieldSectionIndex,
          ),
        hideIfTrue: {
          and: [
            {
              path: 'reportDetails.ministerialDirectiveCode',
              conditions: (value) => !isFieldBlank(value),
            },
          ],
        },
        mustExistInPayload: false,
        mustHaveValueIfExist: false,
        formToPayloadValueConversion: (formValue, formValues) => {
          if (formValues.reportDetails?.ministerialDirectiveCode) {
            return {}; // We dont want to send this field to the backend if the ministerial directive code is present
          }

          return {
            descriptionOfSuspiciousActivity: formValue,
          };
        },
      },
      {
        type: U21FormFieldTypes.SELECT,
        name: 'suspicionTypeCode',
        label: 'Suspicion type',
        dependentPaths: (sectionIndex, fieldSectionIndex) =>
          getDependentPaths(
            undefined,
            ['reportDetails.ministerialDirectiveCode'],
            sectionIndex,
            fieldSectionIndex,
          ),
        hideIfTrue: {
          and: [
            {
              path: 'reportDetails.ministerialDirectiveCode',
              conditions: (value) => !isFieldBlank(value),
            },
          ],
        },
        fieldProps: {
          options: FINTRAC_STR_SUSPICION_TYPE_CODES_OPTIONS,
        },
        mustExistInPayload: false,
        mustHaveValueIfExist: false,
        formToPayloadValueConversion: (formValue, formValues) => {
          if (formValues.reportDetails?.ministerialDirectiveCode) {
            return {}; // We dont want to send this field to the backend if the ministerial directive code is present
          }

          return {
            suspicionTypeCode: formValue,
          };
        },
      },
      {
        type: U21FormFieldTypes.MULTISELECT,
        name: 'publicPrivatePartnershipProjectNameCodes',
        label:
          'Public-private partnership project name (Select all applicable projects)',
        dependentPaths: (sectionIndex, fieldSectionIndex) =>
          getDependentPaths(
            undefined,
            ['reportDetails.ministerialDirectiveCode'],
            sectionIndex,
            fieldSectionIndex,
          ),
        hideIfTrue: {
          and: [
            {
              path: 'reportDetails.ministerialDirectiveCode',
              conditions: (value) => !isFieldBlank(value),
            },
          ],
        },
        fieldProps: {
          options: FINTRAC_STR_PROJECT_CODES_OPTIONS,
        },
        required: false,
        mustExistInPayload: true,
        mustHaveValueIfExist: false,
        formToPayloadValueConversion: (formValue, formValues) => {
          if (formValues.reportDetails?.ministerialDirectiveCode) {
            return {}; // We dont want to send this field to the backend if the ministerial directive code is present
          }

          return {
            publicPrivatePartnershipProjectNameCodes: formValue,
          };
        },
      },
      {
        type: U21FormFieldTypes.RADIO_GROUP,
        name: 'politicallyExposedPersonIncludedIndicator',
        label:
          'Is information of politically exposed person (PEP) or head of an international organization (HIO) included in report?',
        fieldProps: {
          options: FINTRAC_STR_YES_NO_OPTIONS,
          horizontal: true,
        },
        defaultValue: false,
        dependentPaths: (sectionIndex, fieldSectionIndex) =>
          getDependentPaths(
            undefined,
            ['reportDetails.ministerialDirectiveCode'],
            sectionIndex,
            fieldSectionIndex,
          ),
        hideIfTrue: {
          and: [
            {
              path: 'reportDetails.ministerialDirectiveCode',
              conditions: (value) => !isFieldBlank(value),
            },
          ],
        },
        required: false,
        mustExistInPayload: false,
        mustHaveValueIfExist: false,
        formToPayloadValueConversion: (formValue, formValues) => {
          if (formValues.reportDetails?.ministerialDirectiveCode) {
            return {}; // We dont want to send this field to the backend if the ministerial directive code is present
          }

          return {
            politicallyExposedPersonIncludedIndicator: formValue,
          };
        },
      },
    ],
  };
